
<template>
  <div class="container-fluid mt-3 p-0">
    <div class="row">
      <div class="col-12 custom-form-label">
        Add diagram
      </div>
    </div>
    <div class="row">
      <div class="col-12 mt-1">
        <input-select3 class="mt-1" v-model="el.DiagramType" v-bind:options="['Pie','Line','Dash','Bar']" />
        <input-select3 class="mt-1" v-if="el.DiagramType == 'Bar'" v-model="el.DiagramSource" v-bind:options="['User','Priority','Status','Location','Value','UserAndStatus']" />
        <input-select3 class="mt-1" v-if="el.DiagramType != 'Dash' && el.DiagramType != 'Bar' && el.DiagramType != 'Pie'" v-model="el.DiagramSource" v-bind:options="['User','Priority','Status','Location','Value','ProcedureType']" />
        <input-select3 class="mt-1" v-if="el.DiagramType == 'Pie'" v-model="el.DiagramSource" v-bind:options="pieOptions" />
        <input-select3 class="mt-1" v-if="el.DiagramType == 'Dash'" v-model="el.DiagramSource" v-bind:options="['ActiveUsers','TasksCreated','TasksDone','CPU','Memory','ThreadsCreated','Efficiency','TasksNotDone']" />
        <input-select3 class="mt-1" v-if="el.DiagramSource == 'Value'" v-model="el.ValueSource" v-bind:options="values" />
        <input type="text" class="form-control ml-1 px-1 col-3" v-model="el.Name" style="display:inline-table;font-size:12px;line-height:20px;height:38px;" />
        <a class="ml-1 mt-1" href="#" @click="add(el)"><i class="icon-add"></i></a>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'diagram-add',
    components: {
    },
    data(){
      return {
        el: {},
        procedurevalues: ['test 1', 'test 2', 'test 3'],
        pieOptions: ['User', 'Priority', 'Status', 'Location', 'Value', 'ProcedureType'],
      }
    },
    props: {
      procedureid: {
        required: false,
        type: Number,
        default:-1,
      },
      value: {
        required: false,
        type: Array,
        default() {
          return null
        }
      },
      list: {
        required: false,
        type: Array,
        default() {
          return null
        }
      },
    },
    methods: {
      //loadProcedure(id) {
      //  var url = '/api/Procedure/GetProcedureDetail?something=' + (new Date()).getTime() + '&procedureId=' + id;
      //  this.$http.get(url).then(async response => {
      //    this.loadElements(response.data)
      //  })
      //},
      //loadElements(procedure) {
      //  var elements = this.getElements(procedure.Elements)
      //  this.procedurevalues = elements;
      //},
      //getElements(inputelements) {
      //  var elements = [];
      //  for (var i = 0; i < inputelements.length; i++) {
      //    elements.push(inputelements[i].Text);
      //    var childElements = this.getElements(inputelements[i].Elements);
      //    for (var k = 0; k < length; k++) {
      //      elements.push(childElements[k]);
      //    }
      //  }
      //  return elements;
      //},
      setProcedure(procedureid) {
        this.procedureid = procedureid;
      },
      add(el) {
        var elementToAdd = JSON.parse(JSON.stringify(el));
        elementToAdd = this.checkName(elementToAdd);
        this.$emit("add", elementToAdd)
        this.el = {};
      },
      updateElement(ele) {        
        if (this.pieOptions.indexOf(ele) == -1) { // doesn't exists yet
          this.pieOptions.push(ele);
        }
      },
      setData(data) {
        this.value = data;
      },
      checkName(el) {
        var name = el.Name;
        if (name == "" || typeof (name) == "undefined" || name == null)
        {
          name = el.DiagramSource;
          if (el.DiagramType == "Pie") {
            name += " distribution";
          }
          else if (el.DiagramType == "Line") {
            name += " over time";
          }
          else if (el.DiagramType == "Dash") {
            name += " value";
          }
          el.Name = name;
        }
        return el;
      }
    },
  created() {

  },
   
  mounted() {

  },
  watch: {
    procedureid: function (newVal, oldVal) {
      //this.loadProcedure(newVal);
      //alert("changed procedureid")
    }
  },
  computed: {
    realValue() {
      return this.value != null ? this.value : this.list;
    },
    values() {
      //if (this.procedureid == -1)
      return this.procedurevalues;
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/components/statistics/diagram-add.vue